import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import HeaderImage from './HeaderImage.png';
import {routes} from '../../constants/';
import styles from './subheader.less';

export class SubHeader extends PureComponent {
    static propTypes = {
        canDismissEvents: PropTypes.bool,
        errorsPresentButHidden: PropTypes.bool,
        oldEvents: PropTypes.arrayOf(PropTypes.array),
        stats: PropTypes.shape({
            total: PropTypes.number,
        }),
    };

    static defaultProps = {
        canDismissEvents: false,
        errorsPresentButHidden: false,
        oldEvents: [],
        stats: {
            total: 0,
        },
    };

    static contextTypes = {
        i18n: PropTypes.func,
    };

    getHeadline(hasErrors = false) {
        if (!hasErrors) {
            return this.context.i18n('johnson.page.headline.neutral');
        }
        if (this.props.canDismissEvents) {
            return this.context.i18n('johnson.page.headline.title.warning');
        }
        return this.context.i18n('johnson.page.headline.title.error');
    }

    render() {
        const {i18n} = this.context;
        const {errorsPresentButHidden, oldEvents, stats} = this.props;
        const hasErrors = stats.total > 0 || oldEvents.length > 0 || errorsPresentButHidden;

        const text = hasErrors ? i18n('johnson.page.subheadline.error')
            : i18n('johnson.page.subheadline.neutral', `<a href="${routes.confluenceHome}">`, '</a>');

        return (
            <div className={styles.wrapper}>
                <img alt={this.getHeadline(hasErrors)} className={styles.headerImage} src={HeaderImage} />
                <h2 className={styles.subHeadline} data-wd-id="header-headline">{this.getHeadline(hasErrors)}</h2>
                <p className={styles.description}>
                    <span dangerouslySetInnerHTML={{__html: text}} />
                </p>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    canDismissEvents: state.events.canDismissEvents,
    errorsPresentButHidden: state.events.errorsPresentButHidden,
    oldEvents: state.events.oldEvents,
    stats: state.events.stats,
});

export default connect(mapStateToProps)(SubHeader);



// WEBPACK FOOTER //
// ./src/components/SubHeader/SubHeader.js